import { render, staticRenderFns } from "./invoice-shopping-cart-page.vue?vue&type=template&id=226f3792&scoped=true&"
import script from "./invoice-shopping-cart-page.vue?vue&type=script&lang=ts&"
export * from "./invoice-shopping-cart-page.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-shopping-cart-page.vue?vue&type=style&index=0&id=226f3792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f3792",
  null
  
)

export default component.exports